<script setup lang="ts">
  import { defineEmits, ref, type PropType } from 'vue';
  import { isLoading } from '~/config/axios.global';
  import TextInput from './CustomTextInput/TextInput.vue';

  //props
  type Type = 'serialnumber' | 'articlenumber';
  const { value, type = 'serialnumber' } = defineProps({
    value: String,
    type: String as PropType<Type>
  });

  //emits
  const emit = defineEmits(['update-value', 'svhc-action-clicked']);

  //variables
  const valueLocal = ref<string>(value || '');
  const inputStatus = ref<string>('');
  const incompleteFormSubmitTry = ref<boolean>(false);
  const win = window as Window;

  //computed
  // const submitButtonEnabled = computed(() => inputStatus.value === 'success');

  //methods
  const updateInputStatus = (status: string) => {
    incompleteFormSubmitTry.value = false
    inputStatus.value = status;
  };

  const updateValue = (_value: string) => {
    valueLocal.value = _value;
    emit('update-value', valueLocal.value);
    if (inputStatus.value == 'success') { // Direkt submit if user has written a correct number
      emitSvhcAction()
    }
  };

  const buttonClicked = () => {
    if (inputStatus.value !== 'success'){
      incompleteFormSubmitTry.value = true
      return
    }
    emitSvhcAction()
  }

  const emitSvhcAction = () => {
    emit('svhc-action-clicked');
  };
</script>

<template>
  <div :class="$gStyle('lh-grid gap-[36px]')">
    <!-- Text -->
    <span
      :class="$gStyle('col-span-full md:col-span-6 xl:col-span-8 row-start-1')"
    >
      <slot name="input-text"></slot>
    </span>

    <!-- Input -->
    <div
      :class="
        $gStyle('col-span-full md:col-span-4 xl:col-span-6 m-0 p-0 row-start-2')
      "
    >
      <TextInput
        @status-changed="updateInputStatus"
        @value-changed="updateValue"
        :type="type"
        :incompleteFormSubmitTry="incompleteFormSubmitTry"
      />

      <!-- Information Link -->
      <patternlib-link
        v-if="type === 'serialnumber'"
        :hide-icon="true"
        :class="$gStyle('mt-3')"
        type="decent"
        variant="cross"
        :label="$t('serialNumber.where-to-find-text')"
        @click="() => win.lh.openPageModalv2('hau-modal-ratingplate')"
      >
      </patternlib-link>
    </div>

    <!-- Search Button -->
    <div
      :class="
        $gStyle('col-span-full md:col-span-4 xl:col-span-6 m-0 p-0 row-start-3')
      "
    >
      <patternlib-button
        display="inline-block"
        :label="$t('textinput.svhc-action-text')"
        :class="$gStyle('col-span-full md:col-span-4 xl:col-span-6 m-0 p-0')"
        style="width: fit-content"
        type="primary"
        :loading="isLoading"
        @click="buttonClicked()"
      >
      </patternlib-button>
    </div>
  </div>
</template>

<style scoped></style>
